module.exports = "/_next/static/images/SafariEnableMediaRecorder4-45e38910d063c23ae3d471aefeeb594f.png";